<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12" class="pb-0">
                <v-data-table
                    class="custom-data-table elevation-1"
                    dense
                    :headers="chequeInfoHeaders"
                    :items="pending"
                    :search="searchCheque"
                >
                    <template v-slot:top>
                        <v-toolbar dense color="white" :elevation="1" height="30px">
                            <v-toolbar-title class="subtitle-2">Pending Cheque Information List</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-form class="custom-form">
                                <v-text-field
                                    v-model="searchCheque"
                                    outlined
                                    dense
                                    hide-details
                                    placeholder="Search Cheque"
                                    append-icon="mdi-magnify"
                                    style="width:300px;"
                                >
                                </v-text-field>
                            </v-form>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-icon small @click="chequeId = item.id;$refs.confirmDialog.dialog = true" color="primary" v-on="on">mdi-circle-edit-outline</v-icon>
							</template>
							<span>Change Status</span>
						</v-tooltip>
					</template>
                </v-data-table>
                <confirm-dialog ref="confirmDialog" @confirm="changeStatus"></confirm-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import confirmDialog from "@/components/Confirm";
export default {
    name: 'PendingCheque',

    components: {
		"confirm-dialog": confirmDialog,
    },

    data: ()=> ({
        chequeId: null,

        chequeInfoHeaders: [
            { text: 'Date', value: 'date' },
            { text: 'Cheque Date', value: 'cheque_date' },
            { text: 'Submit Date', value: 'submit_date' },
            { text: 'Cheque No', value: 'cheque_number' },
            { text: 'Bank Name', value: 'bank_name' },
            { text: 'Patient Name', value: 'patient.name' },
            { text: 'Cheque Status', value: 'cheque_status' },
            { text: 'Cheque Amount', value: 'cheque_amount' },
            { text: 'Action', value: 'action' },
        ],
        searchCheque: ''
    }),

    computed: {
        pending() {
            return this.$store.getters['cheque/cheques'].filter( cheque => cheque.cheque_status == 'Pending')
        }
    },

    created() {
        this.getPendingCheque();
    },

    methods: {
        getPendingCheque() {
            this.$store.dispatch('cheque/getCheques');
        },

        changeStatus() {
            this.$store.dispatch('cheque/changeStatus', { id: this.chequeId })
            this.$refs.confirmDialog.dialog = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .v-icon.v-icon {
       font-size: 18px !important;
       top: -3px !important;
    }
    .v-icon.v-icon[data-v-1f38b4e5] {
        font-size: 14px !important;
        top: 0px !important; 
    }
    .v-messages {
        flex: 1 1 auto;
        font-size: 12px;
        min-height: 0px !important;
        max-height: 0px!important;
        min-width: 1px;
        position: relative;
    }
</style>